module.exports = __webpack_public_path__ + "static/media/promocoes-cashback.0628fb43.jpg";